import Button from './button';

export default class Secondary extends Button {
  get buttonVariant() {
    return 'secondary';
  }
}
